export default "__VITE_ASSET__NPc84BTm__"